/**
 * The "send me new sets and tips" box on the sign-in page, carried to `/session`.
 *
 * The box is ticked before there is an account to write it to, and an e-mail
 * link finishes the sign-in on a later page load. So it waits here until the
 * first `/session` after sign-in delivers it. A link opened in another browser
 * loses it — the switch on `/account` is where it can always be given.
 */
const KEY = "marketing-consent";

export function pendingMarketingConsent(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setPendingMarketingConsent(on: boolean): void {
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode: the box is lost, and the switch on /account is the way to give it */
  }
}
